const connectors = {
    page_title: 'کانکتورها',
    title: 'کانکتورها',
    subtitle: 'کانکتورها را برای فعال‌سازی ورود بدون رمز عبور و ورود اجتماعی تنظیم کنید',
    create: 'افزودن کانکتور اجتماعی',
    config_sie_notice: 'کانکتورها را تنظیم کرده‌اید. مطمئن شوید که در <a>{{link}}</a> پیکربندی شده است.',
    config_sie_link_text: 'تجربه ورود',
    tab_email_sms: 'کانکتورهای ایمیل و پیامک',
    tab_social: 'کانکتورهای اجتماعی',
    connector_name: 'نام کانکتور',
    view_config: 'مشاهده پیکربندی',
    demo_tip: 'حداکثر تعداد پیام‌های مجاز برای این کانکتور نمایشی به ۱۰۰ محدود است و برای استقرار در محیط تولید توصیه نمی‌شود.',
    social_demo_tip: 'کانکتور نمایشی صرفاً برای اهداف نمایشی طراحی شده و برای استقرار در محیط تولید توصیه نمی‌شود.',
    connector_type: 'نوع',
    placeholder_title: 'کانکتور اجتماعی',
    placeholder_description: 'لاگتو کانکتورهای ورود اجتماعی پرکاربرد زیادی ارائه داده است و در عین حال می‌توانید با پروتکل‌های استاندارد کانکتور خود را بسازید.',
    save_and_done: 'ذخیره و اتمام',
    type: {
        email: 'کانکتور ایمیل',
        sms: 'کانکتور پیامک',
        social: 'کانکتور اجتماعی',
    },
    setup_title: {
        email: 'راه‌اندازی کانکتور ایمیل',
        sms: 'راه‌اندازی کانکتور پیامک',
        social: 'افزودن کانکتور اجتماعی',
    },
    guide: {
        subtitle: 'راهنمای گام به گام برای پیکربندی کانکتور شما',
        general_setting: 'تنظیمات عمومی',
        parameter_configuration: 'پیکربندی پارامترها',
        test_connection: 'آزمایش اتصال',
        name: 'نام برای دکمه ورود اجتماعی',
        name_placeholder: 'نام دکمه ورود اجتماعی را وارد کنید',
        name_tip: 'نام دکمه کانکتور به صورت «ادامه با {{name}}» نمایش داده می‌شود. به طول نام توجه کنید تا خیلی طولانی نشود.',
        connector_logo: 'لوگوی کانکتور',
        connector_logo_tip: 'لوگو روی دکمه ورود کانکتور نمایش داده می‌شود.',
        target: 'نام ارائه‌دهنده هویت',
        target_placeholder: 'نام ارائه‌دهنده هویت کانکتور را وارد کنید',
        target_tip: 'مقدار «نام IdP» می‌تواند یک رشته شناسه منحصربه‌فرد برای تمایز هویت‌های اجتماعی شما باشد.',
        target_tip_standard: 'مقدار «نام IdP» می‌تواند یک رشته شناسه منحصربه‌فرد برای تمایز هویت‌های اجتماعی شما باشد. این تنظیم پس از ساخت کانکتور قابل تغییر نیست.',
        target_tooltip: '«نام IdP» در کانکتورهای اجتماعی لاگتو به «منبع» هویت‌های اجتماعی شما اشاره دارد. در طراحی لاگتو، «نام IdP» یکسان برای یک پلتفرم خاص برای جلوگیری از تعارض پذیرفته نمی‌شود. قبل از افزودن کانکتور بسیار دقت کنید زیرا پس از ایجاد نمی‌توانید مقدار آن را تغییر دهید. <a>بیشتر بدانید</a>',
        target_conflict: 'نام IdP وارد شده با کانکتور موجود <span>name</span> مطابقت دارد. استفاده از نام idp یکسان ممکن است باعث رفتار غیرمنتظره ورود شود که کاربران از طریق دو کانکتور مختلف به یک حساب دسترسی داشته باشند.',
        target_conflict_line2: 'اگر می‌خواهید کانکتور فعلی را با همان ارائه‌دهنده هویت جایگزین کنید و به کاربران قبلی اجازه دهید بدون ثبت‌نام مجدد وارد شوند، لطفاً کانکتور <span>name</span> را حذف کرده و یک کانکتور جدید با همان «نام IdP» ایجاد کنید.',
        target_conflict_line3: 'اگر می‌خواهید به یک ارائه‌دهنده هویت متفاوت متصل شوید، لطفاً «نام IdP» را تغییر داده و ادامه دهید.',
        config: 'JSON پیکربندی خود را وارد کنید',
        sync_profile: 'همگام‌سازی اطلاعات پروفایل',
        sync_profile_only_at_sign_up: 'فقط در هنگام ثبت‌نام همگام‌سازی شود',
        sync_profile_each_sign_in: 'در هر بار ورود همگام‌سازی انجام شود',
        sync_profile_tip: 'پروفایل پایه را از ارائه‌دهنده اجتماعی همگام‌سازی کنید، مانند نام و آواتار کاربران.',
        enable_token_storage: {
            title: 'ذخیره توکن‌ها برای دسترسی مداوم به API',
            description: 'توکن‌های دسترسی و بازیابی را در Secret Vault ذخیره کنید. امکان فراخوانی خودکار API بدون نیاز به تأیید مجدد کاربر را فراهم می‌کند. مثال: به AI Agent خود اجازه دهید با مجوز دائمی رویدادها را به Google Calendar اضافه کند. <a>نحوه فراخوانی APIهای شخص ثالث را بیاموزید</a>',
        },
        callback_uri: 'URI تغییر مسیر (Callback URI)',
        callback_uri_description: 'URIهای تغییر مسیر مقصدهایی هستند که کاربران پس از مجوز اجتماعی به آن‌ها هدایت می‌شوند. همه URIهای نمایش‌داده‌شده را به پیکربندی IdP خود اضافه کنید.',
        callback_uri_custom_domain_description: 'اگر از چندین <a>دامنه سفارشی</a> در لاگتو استفاده می‌کنید، مطمئن شوید که تمام URI‌های callback مربوطه را به IdP خود اضافه کرده‌اید تا ورود اجتماعی در همه دامنه‌ها کار کند.\n\nدامنه پیش‌فرض لاگتو (*.logto.app) همیشه معتبر است — فقط در صورتی که می‌خواهید از ورود با آن دامنه نیز پشتیبانی کنید، آن را اضافه کنید.',
        acs_url: 'آدرس سرویس مصرف‌کننده تأییدیه',
    },
    platform: {
        universal: 'عمومی',
        web: 'وب',
        native: 'بومی',
    },
    add_multi_platform: ' از چندین پلتفرم پشتیبانی می‌کند، یک پلتفرم را برای ادامه انتخاب کنید',
    drawer_title: 'راهنمای کانکتور',
    drawer_subtitle: 'دستورالعمل‌ها را برای یکپارچه‌سازی کانکتور خود دنبال کنید',
    unknown: 'کانکتور ناشناخته',
    standard_connectors: 'کانکتورهای استاندارد',
    create_form: {
        third_party_connectors: 'ارائه‌دهندگان شخص ثالث را برای ورود اجتماعی سریع، پیوند حساب اجتماعی و دسترسی به API یکپارچه کنید. <a>بیشتر بدانید</a>',
        standard_connectors: 'یا می‌توانید کانکتور اجتماعی خود را با یک پروتکل استاندارد سفارشی‌سازی کنید.',
    },
};
export default Object.freeze(connectors);
